import Model from './ModelPortal'

export default class PurchaseDocumentCategory extends Model {
  resource() {
    return "purchase-document-categories";
  }
}
